// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__3gFIZ","fullpage":"Loading_fullpage__12R1o animations_fadeIn__2xk0P"};